<template>
  <div class="faq">
    <section class="g-bg-gray-light-v5">
      <div class="container g-py-50">
        <div class="text-center">
          <div class="align-self-center">
            <h2 class="h3 g-font-weight-300 w-100 g-mb-10 g-mb-0--md">智郵易FAQ</h2>
          </div>
        </div>
      </div>
    </section>
    <section class="container g-pb-100">
      <div class="u-shadow-v11 rounded g-py-100 g-mb-100">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="text-center g-mb-60">
              <h2 class="g-font-weight-600 text-uppercase mb-2">投寄前</h2>
            </div>
            <el-collapse v-model="activeNames1">
              <el-collapse-item
                v-for="(item, key) in faq1"
                :key="key"
                :title="item.q" :name="key"
              >
                <div v-html="item.a"></div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <div class="u-shadow-v11 rounded g-py-100 g-mb-100">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="text-center g-mb-60">
              <h2 class="g-font-weight-600 text-uppercase mb-2">投寄中</h2>
            </div>
            <el-collapse v-model="activeNames2">
              <el-collapse-item
                v-for="(item, key) in faq2"
                :key="key"
                :title="item.q" :name="key"
              >
                <div v-html="item.a"></div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <div class="u-shadow-v11 rounded g-py-100 g-mb-100">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="text-center g-mb-60">
              <h2 class="g-font-weight-600 text-uppercase mb-2">投寄後</h2>
            </div>
            <el-collapse v-model="activeNames3">
              <el-collapse-item
                v-for="(item, key) in faq3"
                :key="key"
                :title="item.q" :name="key"
              >
                <div v-html="item.a"></div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

const phoneNumber = '<a href="tel://85222751314">2275 1314</a>';

export default {
  name: 'FAQ',
  data() {
    return {
      activeNames1: [],
      activeNames2: [],
      activeNames3: [],
      faq1: [
        {
          q: '可投寄什麼商品？',
          a: '【智郵易】提供的國際物流服務，除國家禁運商品外，大部份商品都可經【智郵易】寄往不同國家或地區。',
        },
        {
          q: '能否寄奶粉到中國？',
          a: '按中國香港《2013年進出口(一般)(修訂)規例》(修訂規例)，除非獲發出口許可證，否則規定禁止從香港輸出供36個月以下嬰幼兒食用的配方粉(包括奶粉或豆奶粉)，所以【智郵易】服務暫時不能提供此服務。',
        },
        {
          q: '有什麼不可以投寄',
          a: `請參考【智郵易】拒收物品清單, 或可從以下地點獲取資訊<br />
              1. 【智郵易】微信官方賬號<br />
              2. 【智郵易】官網 ${window.location.origin}<br />
              3. 【智郵易】個人中心FAQ`,
        },
        // {
        //   q: '是否一定要使用【智郵易】專用快郵遞袋？',
        //   a: `使用【智郵易】服務時，系統會自動以專用快郵遞袋的大小來分辨及計算您的運費，只要您的商品能符合快郵遞袋的大小，快郵遞袋沒有損壞並能完整封口，就可享用【智郵易】服務。<br />
        //     如使用非官方郵遞袋，則需自行包裝貨物，並確保包裝有足夠保護力及完全封口才好投寄，否則【智郵易】有權拒收或退回。`,
        // },
        {
          q: '什麼情況下【智郵易】會拒收／退回郵包，拒收／退回郵包會如何處理？',
          a: `
            在以下情況，【智郵易】可能拒收閣下遞投寄的郵包<br>
            1. 投寄郵包中包含拒收物品清單中列明的商品<br>
            2. 投寄郵包中包含未申報或申報類別錯誤的商品<br>
            <!--3. 專用快郵遞袋或【智郵易】未收件前快郵遞袋中商品已出現破損<br>-->
            <!--4. 專用快郵遞袋未封好或無法封口<br>-->
            3. 沒有足夠保護力或沒有完全封口的自行包裝貨物<br>
            4. 未有提供商品價值証明(銷售單據或發票)而客戶不接納【智郵易】對該商品估值並繳納應付的附加服務費<br>
            5. 投寄違禁品或虛報貨物資料<br>
            <p></p>
            被拒收郵包的處理如下：<br>
            客戶需自行到以下指定地點取回整個郵包或該項不能投寄商品。<br>
            - 如【智郵易】未於投寄點收取該郵包，請於該訂單的原投寄點取回，相關安排由投寄點所屬商戶及客戶自行協商。<br>
            - 如郵包已收回至【智郵易】處理中心，客戶必需於郵包投寄當日起計30天內於【智郵易】處理中心領回郵包，逾期未認領，該郵包及商品將被銷毀，不作另行通知或賠償。<br>
            - 客戶未能親臨，可自行安排其它親友或物流公司收取該郵包。
            <p></p>
            被退回郵包的處理如下：<br>
            客戶需自行到以下指定地點取回整個郵包或該項不能投寄商品。<br>
            - 客戶必需於收到通知後起計30天內於【智郵易】處理中心領回郵包，逾期未認領，該郵包及商品將被銷毀，不作另行通知或賠償。<br>
            - 客戶未能親臨，可自行安排其它親友或物流公司收取該郵包。<br>
            - 退回郵包之運費將不獲退還。
          `,
        },
        //{
        //  q: '物流是上門收貨嗎？商品包裝費用由誰付？',
        //  a: '【智郵易】費用包含了自寄運費。如客人需要上門收件，每次满10件或以上可豁免收取HK$30上門取件費, 未符合條件者則不獲豁免。上門取件費會於下單系統內自動計算。',
        //},
        {
          q: '未能提供或遺失商品發票副本怎麼辦?\n',
          a: `
          如客戶無法提供商品售價証明，本公司將以商品一般市場正式零售價作為基礎進行商品價值估算及/或相關附加費估算，客戶不得對該估算有任何異議。<br>
          `,
        },
        {
          q: '服務費包含什麼項目',
          a: '服務費包含運費、申報及清關服務(但不含應繳納稅項)。',
        },
        {
          q: '海關納稅證明',
          a: `通過【智郵易】的物流方式是不會提供納稅證明的，原因是【智郵易】通過整批郵包申報及個人物品方式納稅，<br />
              無法分拆單一郵包提供納稅證明。但是，在物流追踪信息中會顯示相關的國際郵包編號，那就必然是正規清關及繳納海關制定的稅項。`,
        },
        {
          q: '如客戶遺失或商品發票副本怎麼辨？',
          a: '客戶須出示零售價格證明(即發票或銷售收據)，否則【智郵易】有絕對權利對商品進行估值。',
        },
        {
          q: '【智郵易】條款',
          a: '詳情請參閱 <a href="https://e-smartship.com/terms">https://e-smartship.com/terms</a>',
        },
        {
          q: '【智郵易】加盟店舖可以在那裡查詢',
          a: '可到【智郵易】官網，【智郵易】微信公眾號查詢或聯絡【智郵易】客服。',
        },
        {
          q: '需要幾天時間才能收到快郵遞？',
          a: `
          【智郵易】屬國際物流服務，因涉及跨境清關，相關快郵遞時間會因應不同國家及不同情況而有所不同，詳情請與客服查詢。<br>`,
        },
        {
          q: '如何聯絡客服？',
          a: `
          1. 線上客服 > 【智郵易】微信公眾號<br>
          2.電話客服 > 客服熱線號碼 : ${phoneNumber}<br>
          (服務時間:星期一至星期五早上10點至下午6點)<br>
          3. WhatsApp客服 : <a target="_blank" href="https://wa.me/85290694873">https://wa.me/85290694873</a>
          `,
        },
      ],
      faq2: [
        {
          q: '不懂得怎樣下單',
          a: `請瀏覽 <a href="/process" target="_blank">${window.location.origin}/process</a> 或聯絡客服`,
        },
        {
          q: '為什麼寄件人/收件人列表中沒有資料？',
          a: '按寄件人/收件人列表中右上角"+"添加資料後，收件人/寄件人資料才會記錄在你個人地址簿及顯示在寄件人/收件人列表中',
        },
        // {
        //   q: '上傳照片內容',
        //   a: `
        //   1. 商品發票；<br>
        //   2. 郵包的全貌
        //   `,
        // },
        // {
        //   q: '如何使用優惠',
        //   a: `
        //   【智郵易】會提供指定優惠給店舖分為兩種:<br>
        //   1.優惠劵-可以在結算頁面中按圖案輸入相關的優惠碼進行驗證使用相關優惠。<br>
        //   2.折扣-當【智郵易】與指定【智郵易】加盟店合作推廣時，當使用該店舖的【智郵易】專用快郵遞袋將會自動顯示相關優惠
        //   `,
        // },
        {
          q: '接受那種支付方法？',
          a: `
            微信小程序下單接受微信支付<br>
            手機應用程式下單接受微信支付、支付寶及銀聯、Visa及Matercard信用卡。
          `,
        },
        {
          q: '【智郵易】收費幾時可以知道？',
          a: '完成下單程序後, 系統將會自動計算出所有您需要支付的費用總數。',
        },
      ],
      faq3: [
        {
          q: '如何追蹤我已投寄的快郵遞？',
          a: `
          1.可以於訂單查詢中了解訂單當前狀態並按物流追蹤了解訂單物流詳情。<br>
          2.【智郵易】提供專用查詢系統供客戶查詢快郵遞狀態，客戶可使用微信小程序或手機應用程式，進入快郵遞查詢系統，輸入運單號查詢相關資料。<br>
          3.客戶亦可經【智郵易】客服查詢相關資料。
          `,
        },
        {
          q: '當收件人收到由"廣東省郵政速遞"發出的短訊，這是代表什麽？',
          a: '此短信是由中國郵政按中國海關要求給收件人發送，代表郵包需要進行二次申報，所有寄往中國國內的郵包均有幾會被中國海關抽檢，屬於正常程序。',
        },
        {
          q: '為什麽要申報，申報是什麽意思？',
          a: `
          每一件進口中國的郵包均有機會被海關檢查，海關將要求收件人進行二次或補充申報，目的是確認收件人及郵包信息無誤，為收件人必須履行的責任。當中國郵政發出通知後，【智郵易】客服將與您聯繫並提供指引，
          如閣下收到短訊後未有客服與您聯繫，請主動與【智郵易】客服聯絡。<br>
          1.線上客服 > 【智郵易】微信公眾號<br>
          2.電話客服 > 客服熱線號碼:${phoneNumber}<br>
          (服務時間:星期一至星期五早上10點至下午6點)<br>
          3. WhatsApp客服 : <a target="_blank" href="https://wa.me/85290694873">https://wa.me/85290694873</a><br>
          (服務時間:星期一至星期五早上10點至下午6點)
          `,
        },
        {
          q: '為什麽沒有收到"廣東省郵政速遞"短訊？',
          a: '郵包未被檢查覆核的情況下，中國郵政不會發送該類短訊。如在【智郵易】客服就相關問題聯繫時，你仍未收到短訊，請檢查是否手機設置了陌生短訊攔截及黑名單功能，如一切正常請主動聯絡客服。',
        },
        {
          q: '申報有效期多久？',
          a: '申報有效時間會按因應不同屬地海關要求有所差異, 請收件人收到二次/補充申報短信後按指示及時進行操作，如【智郵易】客服還未跟進，請主動聯絡客服。',
        },
        {
          q: '客人收到的【智郵易】短訊是什麽？',
          a: '此短訊為我司提示客戶，需要處理二次申報時關於詳細操作的短信，我們客服會通過微信、電話、短信等不同的方式指引客人進行二次申報，如【智郵易】客服還未跟進，請主動聯絡客服。',
        },
        {
          q: '為什麽申報時提示查詢不到件？',
          a: `
          需注意的是：<br>
          ①申報註冊的手機號必須為收件人手機號；<br>
          ②牢記密碼，多次輸入錯誤會造成賬戶鎖定2小時；<br>
          ③建議用電腦操作，iOS系統的設備容易造成上傳圖片失敗；以上注意事項在客人辦理過程中均有提示。
          `,
        },
        {
          q: '收件人不會操作，你們可以幫忙代辦嗎？',
          a: '申報過程中涉及個人私隱及海關規範申報要求, 【智郵易】可協助收件人進行申報, 但不能代辦，同時收件人需明白及接受相關私隱披露的風險。',
        },
        {
          q: '收件人不操作二次申報',
          a: '如果郵包出現需要二次申報，收件人於指定申報期內不予辦理，此郵包有機會在中國海關扣留2-3個月，待逾期後自動退回至始發地或銷毀。二次申報的操作時間只需5-10分鐘即可完成，煩請收件人能按時辦理。',
        },
        {
          q: '為什麽申報了還沒有收到件，幫忙催一下？',
          a: '中國海關審核二次申報資料是按照既定流程，在成功提交後一般不會超過7個工作日，【智郵易】客服會持續追蹤此郵包的情況並更新在物流記錄中；如遇特殊情況，請主動聯絡客服。',
        },
        {
          q: '為什麽郵包一直顯示已攬件，沒有下一步物流狀態？為什麽物流一直顯示在清關沒有更新？為什麽通關後還看不到信息？',
          a: `
          從中國香港寄往中國國內的郵包屬於跨境郵包，處理手續繁多，一般時效如下，<br>
          - 清關前預審及申報（1-3個工作日）<br>
          - 海關清關檢驗及清關（1-7個工作日）<br>
          - 通關後會經由國內物流(物流狀態將繼續更新)送至收件人手中（1-7個工作日）。<br>
          如超出以上時效或異常，請聯繫【智郵易】客服跟進
          `,
        },
        {
          q: '如果產品清關不成功，是否需要另付退貨時的運費？',
          a: `
          如使用【智郵易】中國線物流服務，同時付運商品乎合物流條款中的細則，因【智郵易】服務失敗的原因而導致清關不成功,
          將被判定為服務過程中掉失或損毀商品處理，由【智郵易】按服務承諾承擔賠償責任(退回後免費從新寄送或按賠償條款賠付)。
          如未能將郵包退回，可向【智郵易】索取賠償。索取賠償後，【智郵易】將不會退回相關郵包。<br />
          中國海關有機會要求收件人在清關的過程中進行二次申報，這是國家規定收件人必須履行的責任，
          【智郵易】會協助收件人 進行申報，但如收件人不願意、未有或錯誤申報，將被視為消費者的錯誤而【智郵易】無需為此承擔任何責任，因此將不接受索償。
          `,
        },
        {
          q: '運輸過程出現物品破損，責任如何處置？',
          a: `
          在運輸過程中出現破損，基於以下條件，可向【智郵易】索償<br>
          - 收件人發現郵包外包裝破損並拒收<br>
          - 【智郵易】處理中心通知郵包在運輸過程中破損或掉失<br>
          - 基於【智郵易】服務失當而導致清關失敗及未能於60天內退回完整郵包<br><br>

          賠償如下：<br>
          按該筆訂單所有已收取之物流費用3倍,不多於60美元作賠償或免費重寄<br>
          如客戶已選用保險服務，賠償另按協定執行<br>
          `,
        },
        {
          q: '如何幫助客戶了解物流狀態',
          a: `
          1. 如果客戶透過【智郵易】系統下單，在訂單查詢按物流追蹤知道最新物流狀態。<br>
          2.詢問客戶物流跟蹤號，在【智郵易】物流追蹤專頁中查詢。<br />
          3.與客服聯絡查詢
          `,
        },
      ],
    };
  },
};
</script>
